import TimeSheetTabContent from './TimeSheetTabContent';

const LitigationContent = () => (
  <TimeSheetTabContent status="3" emptyStateType="time_sheet_litigation" showStatusColumn />
);

export default LitigationContent;
